import { ClientMethodsTypes, client } from '@/services/v2/client'
import { User } from '../types/user'

const baseUrl = '/api/v1/users'

export const getUser = async () => {
  return await client<User>(baseUrl)
}

export const updateUser = async (user: Partial<User>) => {
  return await client<User>(baseUrl, {
    method: ClientMethodsTypes.GET,
    body: user,
  })
}
